import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';
import { Messages, Patterns } from 'src/app/helpers';

@Component({
  selector: 'app-add-edit-rates',
  templateUrl: './add-edit-rates.component.html',
  styleUrls: ['./add-edit-rates.component.scss']
})
export class AddEditRatesComponent implements OnInit {

  form: FormGroup;
  validationMessages = Messages.validation_messages;
  permissions: any;
  rateTypeDDL=[{name:'Percentage',value:0},{name:'Value',value:1}]
  parcelTypeDDL=[{name:'Envelope',value:'LGENV'},{name:'Box',value:'PKG'}]
  constructor(
    public dialogRef: MatDialogRef<AddEditRatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    public formBuilder: FormBuilder,
    private shipmentService: ShipmentsService,
  ) {
    if (data.id != null) {
      this.shipmentService.getRateSetupById(data.id).subscribe(res => {
        if (res) {
          console.log(res)
          this.form.patchValue(res);
          console.log(this.form.value)
        }
      })
    }
  }
  ngOnInit(): void {
    this.validateForm();
  }
  
  validateForm() {
    this.form = this.formBuilder.group({
      serialId: new FormControl(null),
      rateType: new FormControl(null,Validators.required),
      // parcelType: new FormControl(null,Validators.required),
      ratePercentage: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.Num)])),
      rateValue: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.Num)])),
    });
  }

  rateChange(value){
    if(value){
      if(value.value==0){
        this.form.get('rateValue').setValue(0)
      }
      else{
        this.form.get('ratePercentage').setValue(0)
      }
    }
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.shipmentService.createRateSetup(this.form.value).subscribe(res=>{
      if(res){
        this.dialogRef.close("Success");
      }
      else{
        this.onNoClick();
      }
    })
  }

}
